import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../reduxService/hooks';
import { selectSaveNotification, clearSaveNotification } from '../../store/form/formControlSlice';

/**
 * Global snackbar component for save notifications.
 * Displays success/error messages when projects are saved.
 *
 * Mount this component in Layout.tsx to make it available across all pages.
 */
const SaveNotificationSnackbar: React.FC = () => {
    const dispatch = useAppDispatch();
    const notification = useAppSelector(selectSaveNotification);

    const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
        // Don't close on clickaway to avoid accidental dismissal
        if (reason === 'clickaway') {
            return;
        }
        dispatch(clearSaveNotification());
    };

    if (!notification) {
        return null;
    }

    return (
        <Snackbar open={notification.show} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={handleClose} severity={notification.type} sx={{ width: '100%' }}>
                {notification.message}
            </Alert>
        </Snackbar>
    );
};

export default SaveNotificationSnackbar;
